import React, { useState } from 'react';
import { AccordionSummary, AccordionDetails, Typography, Box, Button } from '@mui/material';
import CustomAccordion from '../../../components/Accordian/accordian';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFetchNotesQuery, useAddNoteMutation } from '../../../api/endpoints/apiConfig'; // Adjust the import path based on your project structure
import { toast } from "react-toastify";
import {dateOptions} from '../../../models/DateFormat';
type Props = {
    facilityId: number; // Pass the facilityId as a prop
    dealId: number; // Pass the dealId as a prop
};
const ReservationNote = ({ facilityId, dealId }: Props) => {
    // Fetch existing notes
    const { data: notesData,  isLoading: notesLoading, refetch  } = useFetchNotesQuery({ facilityId, dealId });
    // Add note mutation
    const [addNote, { isLoading: isAdding }] = useAddNoteMutation();
    const [noteContent, setNoteContent] = useState('');
    const handleAddNote = async () => {   
        if (!noteContent) return; // Prevent submission if the note content is empty
        try {
            var agentName = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
            const noteData = {
                note: noteContent,
                agent: agentName
            };
            // Add note API call
            await addNote({
                facilityId,
                dealId,
                noteData
            }).unwrap();
            toast.info('Note added successfully');
            setNoteContent(''); // Clear the note input after submission
            refetch();
        } catch (error) {
            console.error('Failed to add note:', error);
        }
    };
    return (
        <CustomAccordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant="h3" color="text.secondary">Reservation Notes</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {notesLoading && <Typography>Loading notes...</Typography>}
                {notesData?.notes?.length === 0 && <Typography>No notes available.</Typography>}
                {notesData?.notes?.map((note) => (
                    <Typography key={note.id} mb={1.5} color="text.secondary" fontWeight={500}>
                        <Typography component={'span'} color='text.primary' mr={2}>
                        {new Date(note.created_at).toLocaleString('en-US', dateOptions)} {/* Format date as needed */}
                        </Typography>
                        {note.description}
                        <br></br>
                        <i style={{ color: 'grey' }}>{note.title}</i>   
                    </Typography>
                ))}
                <Box mb={2}>
                    <textarea
                        placeholder='Type a quick note here..'
                        style={{
                            padding: '16px',
                            minWidth: '100%',
                            width: '100%',
                            maxWidth: '100%',
                            minHeight: '80px',
                            maxHeight: '120px',
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                            fontFamily: "'poppins',sans-serif",
                            fontSize: 14,
                        }}
                        id="comments"
                        name="comments"
                        rows={4}
                        cols={50}
                        value={noteContent}
                        onChange={(e) => setNoteContent(e.target.value)} // Update state on change
                    />
                </Box>
                <Box my={3} textAlign={'center'}>
                    <Button
                        variant='contained'
                        size='large'
                        onClick={handleAddNote}
                        disabled={isAdding || !noteContent} // Disable button while adding or if no note content
                    >
                        Add Note
                    </Button>
                </Box>
            </AccordionDetails>
        </CustomAccordion>
    );
};

export default ReservationNote;
